// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__316Wy","header":"ReportDetails_header__2Q0ik","title":"ReportDetails_title__3SL4k","left":"ReportDetails_left__16-TG"};